


















































































import {
  computed,
  defineComponent,
  PropType,
  onMounted,
  onUnmounted
} from '@nuxtjs/composition-api';
import useWindowResize from '~/hooks/useResizeWindow';
import { addCurrency, priceFormat, StatusReference } from '~/helpers/utils';
import Emitter from '@/hooks/useEmitter';
import useWindowScroll from '@/hooks/useScrollWindow';
import useDefaultHeaderToggle from '~/hooks/useDefaultHeaderToggle';

export default defineComponent({
  name: 'StickyBar',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({
        spli_id: 0,
        name: '',
        product_image_galery: [],
        price: 0,
        first_price: 0,
        category: '',
        brand: ''
      })
    },
    productStatusReference: {
      type: Number as PropType<StatusReference>,
      default: StatusReference.IN_STOCK
    },
    isPickupAvailable: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { isDesktop } = useWindowResize();
    const DISPLAY_OFFSET = 500;
    const MOBILE_HEADER_OFFSET = 116;
    // headerHeight - translationY
    const DESKTOP_HEADER_OFFSET = 171 - 40;

    const { passedThreshold: isShown } = useWindowScroll(DISPLAY_OFFSET);
    const useEmitter = Emitter();

    const media = computed(() =>
      props.product.product_image_gallery?.length
        ? props.product.product_image_gallery[0].media_url
        : ''
    );

    const currentPrice = computed(() => {
      const priceAfterCashDiscount = props.product.price_after_cash_discount;
      if (
        priceAfterCashDiscount &&
        priceAfterCashDiscount < props.product.price
      ) {
        return priceAfterCashDiscount;
      }
      return props.product.price;
    });

    const normalPrice = computed(() => props.product.price);

    const handlePickup = () => {
      useEmitter.openModalPickUp();
    };

    // HIDE HEADER WHEN SCROLL DOWN
    // SHOW HEADER WHEN SCROLL UP
    const { shouldHideHeader, toggleHideHeader } = useDefaultHeaderToggle();
    const TOGGLE_SCROLL_THRESHOLD_OFFSET = 200;
    let toggleScrollThreshold = TOGGLE_SCROLL_THRESHOLD_OFFSET;
    let oldScrollPos = 0;
    const scrollListener = () => {
      const scrollPos = window.scrollY;
      if (shouldHideHeader.value) {
        if (scrollPos < toggleScrollThreshold) {
          toggleHideHeader(false);
          toggleScrollThreshold = scrollPos + TOGGLE_SCROLL_THRESHOLD_OFFSET;
        } else if (scrollPos > oldScrollPos) {
          toggleScrollThreshold = scrollPos - TOGGLE_SCROLL_THRESHOLD_OFFSET;
        }
      } else if (isShown.value && scrollPos > toggleScrollThreshold) {
        toggleHideHeader(true);
        toggleScrollThreshold = scrollPos - TOGGLE_SCROLL_THRESHOLD_OFFSET;
      } else if (scrollPos < oldScrollPos) {
        toggleScrollThreshold = scrollPos + TOGGLE_SCROLL_THRESHOLD_OFFSET;
      }
      oldScrollPos = scrollPos;
    };

    onMounted(() => {
      window.addEventListener('scroll', scrollListener);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', scrollListener);
    });

    return {
      normalPrice,
      currentPrice,
      isDesktop,
      media,
      isShown,
      MOBILE_HEADER_OFFSET,
      DESKTOP_HEADER_OFFSET,
      priceFormat,
      addCurrency,
      StatusReference,
      shouldHideHeader,
      handlePickup
    };
  }
});
